import { useEffect, useState } from "react";
import { doveCssVars, getDove, subscribeDove, type IDoveTheme } from "./doveTheme";

/** The live theme; re-renders on any change from Payroll Settings. */
export function useDoveTheme(): IDoveTheme {
  const [t, set] = useState(getDove);
  useEffect(() => { const l = () => set(getDove()); const off = subscribeDove(l); l(); return off; }, []);
  return t;
}

/**
 * Put the theme on the document so the Shell's sidebar wears it, in every
 * module (Mikko, 2026-10-11: "apply it across all side navigation"). Called
 * once, from the Shell. The ink still applies to the payroll screens only.
 */
export function useApplyDoveToShell(): void {
  const t = useDoveTheme();
  useEffect(() => {
    const el = document.documentElement;
    if (!t.on) { el.removeAttribute("data-dove"); return; }
    const vars = doveCssVars(t);
    for (const [k, v] of Object.entries(vars)) el.style.setProperty(k, v);
    el.setAttribute("data-dove", "");
    return () => {
      el.removeAttribute("data-dove");
      for (const k of Object.keys(vars)) el.style.removeProperty(k);
    };
  }, [t]);
}
